// extracted by mini-css-extract-plugin
export var content = "_66-3";
export var list = "_66-4";
export var settingsContent = "_66-7";
export var settingsPanel = "_66-8";
export var state = "_66-6";
export var triggerBadge = "_66-2";
export var triggerButton = "_66-1";
export var triggerShell = "_66-0";
export var unreadDot = "_66-5";